import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * CLOUDWEB-18171
 * Р7-Офис. Включить Р7 Офис по кнопке "Редактировать копию" на аттачах
 */

export const R7_FOR_EDITING_ATTACHES = isFeature('r7-for-editing-attaches');
